import React from 'react';
import PropTypes from 'prop-types';
import { groupValidateClasses } from '../utilities';

const RadioButtonsField = ({ input, label, required, meta: { touched, error }, options }) => (
  <div className={groupValidateClasses(touched, error)}>
    {label && (
      <label className={`control-label col-lg-4${required ? ' required' : ''}`}>{label}</label>
    )}
    <div className={label ? 'col-lg-8' : 'col-lg-12'}>
      {options.map(o => (
        <div className="radio" key={o.key}>
          <label className={required ? ' required' : ''}>
            <input
              {...input}
              type="radio"
              value={o.key}
              id={`${input.name}-${o.key}`}
              checked={input.value === o.key}
              onChange={event => input.onChange(event)}
              // className={`custom-control-input ${inputValidateClasses(touched, error)}`}
            />
            {o.value}
          </label>
        </div>
      ))}
      {touched && error && <div className="form-control-feedback">{error}</div>}
    </div>
  </div>
);

RadioButtonsField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.array,
  required: PropTypes.bool,
};

export default RadioButtonsField;
